import appInvoiceItem from "../../views/appPlans/invoiceitem.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("invoiceitem", {
    url: "invoiceitem/:id",
    parent: "app",
    views: {
      view: {
        template: appInvoiceItem,
      },
    },
    reloadOnSearch: false,
    data: { title: "Invoice Item" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/invoiceItem/invoiceItem.urls.js